import { render, staticRenderFns } from "./otodetusercol.vue?vue&type=template&id=2a669b68&scoped=true&"
import script from "./otodetusercol.vue?vue&type=script&lang=js&"
export * from "./otodetusercol.vue?vue&type=script&lang=js&"
import style0 from "./otodetusercol.vue?vue&type=style&index=0&id=2a669b68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a669b68",
  null
  
)

export default component.exports